/**
 * Initial constant for setting Vuex store module
 * for
 * @type {{}}
 */
export const paginationFilterSortInitialObject = {
  filters: null,
  search: {
    type: "general",
    value: ""
  },

  pagination: {
    current_page: 1,
    next_page: null,
    page_count: 0,
    page_size: 25,
    prev_page: 0,
    total_count: 0
  },

  sort: {
    key: "updated_at",
    order: 1
  }
};
